module.exports = __webpack_public_path__ + "static/media/heroImage1.18c42a7f.png";